module.exports = __webpack_public_path__ + "assets/img/7_1552_big.64299bed.jpg";